/* ==========================================================================
   WAQAAR — search.js  ·  Shopify Predictive Search API
   ========================================================================== */
(() => {
  const W = window.WAQAAR;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-results]');
      this.cache = new Map();
      this.controller = null;
      let t;
      this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.search(), 220); });
      this.input.addEventListener('keydown', (e) => this.keyNav(e));
    }

    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      if (this.cache.has(q)) return this.render(this.cache.get(q));
      this.controller?.abort();
      this.controller = new AbortController();
      this.results.innerHTML = '<div class="spinner" aria-hidden="true"></div>';
      try {
        const params = new URLSearchParams({
          q,
          section_id: 'predictive-search',
          'resources[type]': 'product,collection,query,page',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last'
        });
        const res = await fetch(`${W.routes.predictive_search}?${params}`, { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const out = doc.querySelector('#predictive-search-results')?.outerHTML || '';
        this.cache.set(q, out);
        this.render(out);
        W.track('waqaar_search', { query_length: q.length });
      } catch (err) {
        if (err.name !== 'AbortError') this.results.innerHTML = '';
      }
    }

    render(html) {
      this.results.innerHTML = html;
      this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
    }

    keyNav(e) {
      if (!['ArrowDown', 'ArrowUp'].includes(e.key)) return;
      const links = [...this.results.querySelectorAll('a')];
      if (!links.length) return;
      e.preventDefault();
      let i = links.findIndex((a) => a === document.activeElement);
      i = e.key === 'ArrowDown' ? Math.min(i + 1, links.length - 1) : Math.max(i - 1, 0);
      links[i].focus();
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
